import React, { FC, useState } from "react";

// Stripe
import { CardElement } from "@stripe/react-stripe-js";

// UI
import { Box } from "@UI/Components/Box/Box";
import { ZoomDisabled } from "@UI/Components/Helmet/ZoomDisabled";

// Hooks
import useThemeToken from "@UI/hooks/useThemeToken";

// Types
import { StripeError } from "@stripe/stripe-js";

interface Props {
  setCreditCardNumberCompleted: (arg: boolean) => void;
  error: boolean;
  cleanError: () => void;
  setStripeError: (arg: StripeError) => void;
}

export const StripeCreditCardNumberForm: FC<Props> = ({
  setCreditCardNumberCompleted,
  error,
  cleanError,
  setStripeError,
}) => {
  const [focus, setFocus] = useState(false);

  const [gray400, gray500, red500, gray700] = useThemeToken("colors", [
    "gray.400",
    "gray.500",
    "red.500",
    "gray.700",
  ]);

  const onCardElementFocus = () => setFocus(true);
  const onCardElementBlur = () => setFocus(false);
  const onCardElementChange = ({ error, complete }) => {
    if (!!error) setStripeError(error);
    else cleanError();
    setCreditCardNumberCompleted(!!complete);
  };

  return (
    <Box
      bg="white"
      paddingY={2.5}
      paddingX={3}
      borderRadius="lg"
      borderWidth={1}
      borderColor={error ? red500 : !focus ? gray400 : gray700}
      _hover={{ borderColor: error ? red500 : !focus ? gray500 : gray700 }}
      data-testid="stripe-input"
    >
      <ZoomDisabled />
      <CardElement
        data-testid="stripe-form"
        onChange={onCardElementChange}
        onBlur={onCardElementBlur}
        onFocus={onCardElementFocus}
        options={{
          hidePostalCode: true,
          style: {
            base: {
              fontWeight: 100,
              color: error ? undefined : gray700,
              fontSize: "16px",
              "::placeholder": {
                color: gray400,
                fontWeight: 100,
              },
            },
          },
        }}
      />
    </Box>
  );
};
